interface ActiveGlyphProps {
  readonly x: number;
  readonly y: number;
  readonly color: string;
  readonly size?: number;
}

export function ActiveGlyph({ x, y, color, size = 4 }: ActiveGlyphProps) {
  return (
    <g>
      <defs>
        <filter id="glow-filter" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle cx={x} cy={y} r={size} fill={color} filter="url(#glow-filter)" />
    </g>
  );
}
